<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="column is-8">
          <h1 class="title is-3">Facturen aanmaken</h1>

          <div class="columns">
            <div class="column is-6">
              <b-field label="Start datum">
                <b-datepicker
                  placeholder="Start datum"
                  icon="calendar"
                  :readonly="false"
                  v-model="startDate">
                </b-datepicker>
              </b-field>
            </div>
            <div class="column is-6">
              <b-field label="Eind datum">
                <b-datepicker
                  placeholder="Eind datum"
                  icon="calendar"
                  :readonly="false"
                  v-model="endDate">
                </b-datepicker>
              </b-field>
            </div>
          </div>
        </div>

        <!-- <div class="columns is-multiline column is-10">
          <div class="column is-6">
            <div class="field">
              <label class="label">Start verkoopfactuur</label>
              <div class="control">
                <input class="input" type="text" v-model="startSales" placeholder="10001">
              </div>
            </div>
          </div>

          <div class="column is-6">
            <div class="field">
              <label class="label">Start inkoopfactuur</label>
              <div class="control">
                <input class="input" type="text" v-model="startPurchase" placeholder="10002">
              </div>
            </div>
          </div>

          <div class="column is-12">
              <b-field label="Factuur datum">
                <b-datepicker
                  placeholder="Factuur datum"
                  icon="calendar"
                  :readonly="false"
                  v-model="invoiceDate">
                </b-datepicker>
              </b-field>
            </div>
        </div> -->

        <div class="button spacing-top-10 is-primary" :class="{ 'is-loading': inprogress }" @click="save">Opslaan en verzenden</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    const today = new Date()

    return {
      startDate: today,
      endDate: today,
      invoiceDate: today,
      inprogress: false
      // startSales: null,
      // startPurchase: null
    }
  },
  methods: {
    async save () {
      this.inprogress = true

      try {
        await this.$store.dispatch('createInvoicesAndSend', {
          startDate: this.startDate,
          endDate: this.endDate,
          invoiceDate: this.invoiceDate
        })

        this.$snackbar.open({
          duration: 5000,
          message: 'de facturen zijn in de wachtrij geplaatst',
          type: 'is-primary',
          actionText: 'OK'
        })

        await this.$store.dispatch('getConfirmationReceipts', true)
        await this.$store.dispatch('getPurchasesCompleted', true)
        await this.$store.dispatch('getSalesCompleted', true)

        this.$router.push({ name: 'invoices.confirmation' })
      } catch (err) {
        this.$snackbar.open({
          duration: 5000,
          message: 'Er ging iets fout tijdens het aanmaken van de facturen',
          type: 'is-danger',
          actionText: 'OK'
        })
      } finally {
        this.inprogress = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/invoices/new.vue